export default "__VITE_ASSET__89421f19__"